import * as THREE from 'three';

/**
 * Recursively disposes all geometries, materials, and textures
 * inside an Object3D hierarchy.
 *
 * Call this before removing a model from the scene to free GPU memory.
 */
export function disposeObject(object: THREE.Object3D): void {
  object.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return;

    child.geometry.dispose();

    const materials = Array.isArray(child.material)
      ? child.material
      : [child.material];

    materials.forEach(disposeMaterial);
  });
}

function disposeMaterial(material: THREE.Material): void {
  material.dispose();

  // Dispose any textures attached to the material
  const mat = material as unknown as Record<string, unknown>;
  const textureSlots = [
    'map',
    'normalMap',
    'roughnessMap',
    'metalnessMap',
    'emissiveMap',
    'aoMap',
    'alphaMap',
    'envMap',
    'lightMap',
  ];

  textureSlots.forEach((slot) => {
    const tex = mat[slot];
    if (tex instanceof THREE.Texture) tex.dispose();
  });
}
